module.exports = __webpack_public_path__ + "grass.5f910389.jpg";